// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionSection-module__container--zVUWs","button":"SubscriptionSection-module__button--WSUPv","header":"SubscriptionSection-module__header--wa_Pf"};